import { render, staticRenderFns } from "./transport_detail.vue?vue&type=template&id=bdd2a0c4&scoped=true"
import script from "./transport_detail.vue?vue&type=script&lang=js"
export * from "./transport_detail.vue?vue&type=script&lang=js"
import style0 from "./transport_detail.vue?vue&type=style&index=0&id=bdd2a0c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd2a0c4",
  null
  
)

export default component.exports